import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import MainTopNav from "../component/MainTopNavComponent.vue";
import MainFooter from "../component/MainFooterComponent.vue";
import ExternalAccountComponent from "../component/ExternalAccountComponent.vue";
import VersionComponent from "../component/VersionComponent.vue";
import { useRoute } from "vue-router";
import FlashMessengerComponent from "../component/FlashMessengerComponent.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppPage',
  setup(__props) {

const route = useRoute();


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, { class: "bg-white" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          _createVNode(MainTopNav),
          _createVNode(FlashMessengerComponent),
          _createVNode(_component_router_view, { class: "bg-white h-100" }),
          _createVNode(VersionComponent),
          _createVNode(ExternalAccountComponent)
        ]),
        _: 1 /* STABLE */
      }),
      (_unref(route).fullPath.includes('/account/'))
        ? (_openBlock(), _createBlock(MainFooter, { key: 0 }))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}
}

})